(ns basic-components.inputs.toggle
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [value placeholder class-name custom-class-name
                has-focus? toggle-on-text toggle-off-text
                tooltip on-focus! on-blur! on-change!
                on-key-down! disabled?]}
        args
        edit-value (if (boolean? value) value false)]
    [:div
     {:class-name (fu/cs (when custom-class-name custom-class-name)
                         "component-toggle")}
     (fu/overlay-if
      tooltip
      [rbs/OverlayTrigger
       {:placement     "right"
        :popper-config {:modifiers [{:name    "preventOverflow"
                                     :options {:main-axis false}}]}
        :overlay       tooltip}]
      [:label
       {:class-name (fu/cs "component-toggle__background"
                           (when edit-value "checked")
                           (when disabled? "disabled")
                           (when has-focus? "focused"))}
       [:input
        (merge {:ref         (fn [e]
                               (when (and e
                                          (not= e (:input-dom-node @dom-atom)))
                                 (swap! dom-atom assoc :input-dom-node e)))
                :type        "checkbox"
                :checked     edit-value
                :class-name  (fu/cs "component-toggle__checkbox"
                                    (when has-focus? "focus")
                                    class-name)
                :on-focus    (fn [e]
                               (swap! dom-atom assoc :focus? true)
                               (swap! dom-atom dissoc :blur-timeout)
                               (when (fn? on-focus!)
                                 (on-focus! e)))
                :on-blur     (fn [e]
                               (let [checked? (-> e
                                                  .-target
                                                  .-checked)]
                                 (swap! dom-atom dissoc :focus?)
                                 (when (fn? on-blur!)
                                   ;; Safari does not blur checkbox so we're triggering blur event here
                                   ;; to avoid duplicate blur events, we add a flag to ignore blur on other browsers
                                   (when-not (:blur-timeout @dom-atom)
                                     (on-blur! e checked?)))))
                :on-key-down on-key-down!
                :on-change   (fn [e]
                               (let [checked? (-> e
                                                  .-target
                                                  .-checked)]
                                 (when (fn? on-change!)
                                   (on-change! e checked?))
                                 (when (fn? on-blur!)
                                   ;; Safari does not blur checkbox so we're triggering blur event here
                                   ;; to avoid duplicate blur events, we add a flag to ignore blur on other browsers
                                   (swap! dom-atom assoc
                                          :blur-timeout
                                          (fu/timeout 10
                                                      (fn []
                                                        (swap! dom-atom dissoc :blur-timeout))))
                                   (on-blur! e checked?))))}
               (when disabled?
                 {:disabled (boolean disabled?)}))]
       [:span.component-toggle__dot]
       [:span.component-toggle__text
        (if edit-value toggle-on-text toggle-off-text)]])
     [:div.component-toggle__remaining-space]]))

(defmethod editor :editor.type/toggle
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Toggle"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value) ;; save complete -> reset temp state
                                                        (deref dom-atom)
                                                        (when-let [dom-node (:input-dom-node @dom-atom)]
                                                          (.blur dom-node)))))
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/toggle
  [args]
  (if (:value args)
    (or (:toggle-on-text args)
        (loc/tr :true))
    (or (:toggle-off-text args)
        (loc/tr :false))))

(defmethod viewer :editor.type/toggle
  [args]
  (r/create-class
   {:display-name   "toggle/viewer"
    :reagent-render (fn [args]
                      [:div.preview.preview-toggle
                       (display-string args)])}))
